var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"memoContentRef",staticClass:"memoMath-frameCanvas"},[_c('img',{attrs:{"src":_vm.params.questionUrl,"alt":"question"}}),_c('pen-canvas-math',{attrs:{"name":_vm.canvasName}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }